import { useLayoutEffect, useRef, useState } from "react";
import "./pdfNavigation.css";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";

import ZoomControls, { PageFitControls } from "./ZoomControls";
const PdfNavigation = ({
  handleSearch,
  searchTerm,
  searchProgress,
  pageNumber = 1,
  setPageNumber,
  totalPages,
  onZoomChange,
  zoomScale,
  scrollPageToView,
  isChatOpen,
  showSearch = true,
  alignWithDocument = false,
  documentViewport,
}) => {
  const [isfocus, setIsFocus] = useState(false);
  const toolbarRef = useRef(null);

  useLayoutEffect(() => {
    const toolbar = toolbarRef.current;
    if (!alignWithDocument || !toolbar || !documentViewport) return;

    // The footer spans both sidebars, so its midpoint differs from the document's.
    const alignControls = () => {
      const toolbarBounds = toolbar.getBoundingClientRect();
      const documentBounds = documentViewport.getBoundingClientRect();
      const documentCenter = documentBounds.left + documentBounds.width / 2 - toolbarBounds.left;
      toolbar.style.setProperty("--pdf-document-center", `${documentCenter}px`);
    };

    alignControls();
    const observer = new ResizeObserver(alignControls);
    observer.observe(toolbar);
    observer.observe(documentViewport);
    return () => observer.disconnect();
  }, [alignWithDocument, documentViewport]);

  const handleChangePageNumber = (event) => {
    const newPageNumber = Number(event.target.value);
    if (newPageNumber >= 1 && newPageNumber <= totalPages) {
      scrollPageToView(newPageNumber, setPageNumber);
    }
  };

  const incrementPageNumber = () => {
    if (pageNumber <= totalPages + 1) {
      scrollPageToView(pageNumber + 1, setPageNumber);
    }
  };
  const decrementPageNumber = () => {
    if (pageNumber >= 1) {
      scrollPageToView(pageNumber - 1, setPageNumber);
    }
  };

  const pageControls = (
    <div
      className={`center-controls d-flex align-items-center justify-content-center${alignWithDocument ? "" : " ms-auto"}`}
      style={{ gap: "5px" }}
    >
      <button
        type="button"
        aria-label="Previous page"
        onClick={decrementPageNumber}
        disabled={pageNumber <= 1}
        style={{
          height: "21px",
          padding: 0,
          margin: 0,
          minWidth: "25px",
          width: "25px",
        }}
        className="d-flex align-items-center justify-content-center btns-bottom-bar-document-popup"
      >
        <FaChevronUp
          size={18}
          style={{
            color: "#009900",
          }}
        />
      </button>
      <input
        id="pageno"
        name="pageNumber"
        aria-label="Page number"
        inputMode="numeric"
        autoComplete="off"
        className="pageno form-control p-0 color-main"
        value={pageNumber}
        onChange={handleChangePageNumber}
        min="1"
        max={totalPages}
        style={{
          height: "21px",
          fontWeight: "600",
          minWidth: "40px",
          maxWidth: "60px",
        }}
      />
      <button
        type="button"
        aria-label="Next page"
        onClick={incrementPageNumber}
        disabled={pageNumber >= totalPages}
        style={{
          height: "21px",
          padding: 0,
          margin: 0,
          minWidth: "25px",
          width: "25px",
        }}
        className="d-flex align-items-center justify-content-center btns-bottom-bar-document-popup"
      >
        <FaChevronDown
          size={18}
          style={{
            color: "#009900",
          }}
        />
      </button>
    </div>
  );

  if (alignWithDocument) {
    return (
      <div
        ref={toolbarRef}
        className="pdftoolbar pdf-document-toolbar align-items-center m-0"
        style={{ height: "25px", minHeight: "25px", background: "var(--primary)" }}
      >
        <div className="pdf-toolbar-zoom-slot">
          <ZoomControls onZoomChange={onZoomChange} zoomScale={zoomScale} showFitControls={false} />
        </div>
        {pageControls}
        <div className="pdf-toolbar-fit-slot">
          <PageFitControls onZoomChange={onZoomChange} responsive />
        </div>
      </div>
    );
  }

  return (
    <div
      className="pdftoolbar  p-l-5 p-r-5 align-items-center m-0"
      style={{
        height: "25px",
        background: "var(--primary)",
        minHeight: "25px",
      }}
    >
      <div className="col-md-3 col-lg-5 col-xl-6 col-xxl-7 p-0 d-flex align-items-center">
        {/* <button onClick={toggleSidebar} style={{ height: "25px" }}>
          <ViewSidebarOutlined />
        </button> */}
        {showSearch && (
          <div
            className="input-row d-flex-1 p-l-5 min-width-search-document-popup"
            style={{
              height: "21px",
              maxWidth: "600px",
              marginRight: "5px",
              minWidth: "50px",
            }}
          >
            <input
              type="text"
              className="form-control height-21 document-search-text-color "
              placeholder="Type Search Terms to Only Display Pages With Those Terms"
              value={searchTerm}
              onChange={handleSearch}
              onFocus={() => setIsFocus(true)}
              onBlur={() => setIsFocus(false)}
              style={{
                height: "21px",
                fontWeight: "600",
                color: isfocus ? "var(--primary)" : "var(--primary-25)",
              }}
            />
          </div>
        )}
        {/* Page text is now extracted on demand rather than at open, so a
            first search over a long document takes a moment. Only shown while
            that walk is running. */}
        {showSearch && searchProgress?.isSearching && (
          <span
            className="document-search-text-color"
            style={{
              fontSize: "11px",
              fontWeight: "600",
              whiteSpace: "nowrap",
              marginRight: "5px",
            }}
          >
            Searching… {searchProgress.done}/{searchProgress.total}
          </span>
        )}
        {pageControls}
      </div>
      <ZoomControls onZoomChange={onZoomChange} zoomScale={zoomScale} isChatOpen={isChatOpen} />
    </div>
  );
};

export default PdfNavigation;
